import { render, staticRenderFns } from "./DeleteConfirmer.Vue?vue&type=template&id=5ef23928"
import script from "./DeleteConfirmer.Vue?vue&type=script&lang=js"
export * from "./DeleteConfirmer.Vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/DeleteConfirmer.Vue
// module id = 10
// module chunks = 0